import { colorConstants } from 'config/colorConstants';
import { capitalizeFirstLetterOfEachWord } from 'utils/helperMethods';

export const getMinAndMaxValues = (obj: any) => {
    let minVal = Infinity;
    let maxVal = -Infinity;
    Object.keys(obj).forEach((k) => {
        const v = obj[k];
        minVal = Math.min(minVal, v);
        maxVal = Math.max(maxVal, v);
    });
    if (minVal === maxVal) {
        if (minVal > 0) {
            minVal = 0;
        } else {
            maxVal = 0;
        }
    }
    return { minVal, maxVal };
};

export const processGroupData = (groupData: any, disableHover: boolean) => {
    const result: Array<any> = [];
    Object.keys(groupData)?.forEach((key) => {
        const salesVolumeAbs = groupData[key];
        const newObj = {
            sales: salesVolumeAbs,
            labelSales: salesVolumeAbs,
            category: capitalizeFirstLetterOfEachWord(key?.replace(/_/g, ' ')),
            color: Number(salesVolumeAbs) < 0 ? colorConstants.red : colorConstants.limeGreen,
            disableHover: [null, 0].includes(salesVolumeAbs) || disableHover,
            apiParamKey: key,
        };
        result.push(newObj);
    });
    return result;
};
